import { render, staticRenderFns } from "./MotionFeatureRatio.vue?vue&type=template&id=676ac919&scoped=true&"
import script from "./MotionFeatureRatio.vue?vue&type=script&lang=js&"
export * from "./MotionFeatureRatio.vue?vue&type=script&lang=js&"
import style0 from "./MotionFeatureRatio.vue?vue&type=style&index=0&id=676ac919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ac919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676ac919')) {
      api.createRecord('676ac919', component.options)
    } else {
      api.reload('676ac919', component.options)
    }
    module.hot.accept("./MotionFeatureRatio.vue?vue&type=template&id=676ac919&scoped=true&", function () {
      api.rerender('676ac919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Home/components/MotionFeatureRatio.vue"
export default component.exports